import { PauseCircle, PlayCircle } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';

type Props = {
    product_audio: string;
    product_audio_alt: string;
    product_audio_title: string;
};

const ProductAudio = ({ product_audio, product_audio_title, product_audio_alt }: Props) => {
    const playerRef = useRef<AudioPlayer>(null);
    const [hasUserInteracted, setHasUserInteracted] = useState(false);
    const [showMiniPlayer, setShowMiniPlayer] = useState(false);
    const [hasAutoplayed, setHasAutoplayed] = useState(false);

    const togglePlayPause = () => {
        const audioElement = playerRef.current?.audio.current;
        if (audioElement) {
            if (audioElement.paused) {
                audioElement.play();
            } else {
                audioElement.pause();
            }
            setHasUserInteracted(true);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;
            setShowMiniPlayer(scrollY > 1200);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        // پخش خودکار فقط یکبار بعد از 5 ثانیه و در صورتی که کاربر هنوز تعامل نکرده باشد
        if (!hasUserInteracted && !hasAutoplayed) {
            const timer = setTimeout(() => {
                const audioElement = playerRef.current?.audio.current;
                if (audioElement && audioElement.paused) {
                    audioElement.play().then(() => {
                        setHasAutoplayed(true);
                    }).catch(() => {
                        // ممکن است مرورگر پخش خودکار را بلاک کند، در این صورت کاری انجام نمی‌دهیم.
                    });
                }
            }, 12000);
            return () => clearTimeout(timer);
        }
    }, [hasUserInteracted, hasAutoplayed]);

    return (
        <div className="relative" style={{direction: 'ltr'}}>
            <AudioPlayer
                ref={playerRef}
                src={product_audio}
                header={product_audio_title}
                footer={product_audio_alt}
                customIcons={{
                    play: <PlayCircle className="size-10 text-[#5284E7]" />,
                    pause: <PauseCircle className="size-10 text-pink" />,
                }}
                onPause={() => setHasUserInteracted(true)}
                onPlay={() => setHasUserInteracted(true)}
            />

            {showMiniPlayer && (
                <div
                    className="fixed bottom-[90px] left-1 bg-white rounded-full shadow-lg w-14 h-14 flex items-center justify-center z-[9999] cursor-pointer"
                    onClick={togglePlayPause}
                >
                    {playerRef.current?.audio.current?.paused ? (
                        <PlayCircle className="size-10 text-[#5284E7]" />
                    ) : (
                        <PauseCircle className="size-10 text-pink" />
                    )}
                </div>
            )}
        </div>
    );
};

export default ProductAudio;
